
import { useState } from "react";
import { Link } from "react-router-dom";
import PageLayout from "../../component/PageLayout";
import IconAddLocation from "../../component/SvgIcon/IconAddLocation";

export default function EditLocation() {
  const [loading] = useState(false);  

  return (
    <PageLayout icon={<IconAddLocation/>} pagetitle="Edit Location">
      <div className="topspace">
        <div className="container-fluid">
          <section className="user-section mb-4">
            <form>
              <div className="form-grid">
              <div className="form-group">
                <label>Location Name <small>*</small></label>
                <input
                  type="text"
                  required
                  className="form-control"
                  autoComplete="new-user"
                  placeholder="Enter Location Name"
                />
              </div>             

              <div className="form-group">
                <label>Country Name<small>*</small></label>
                <input
                  type="text"
                  required
                  className="form-control"
                  autoComplete="new-country"
                  placeholder="Enter Country Name"
                />
              </div>

              <div className="form-group d-flex flex-row">
                <div className="latitudeno d-flex flex-column gap-2 w-50">
                <label>Latitude Number <small>*</small> </label>
                <input
                  type="text"
                  required
                  className="form-control"
                  autoComplete="new-Latitude"
                  placeholder="Enter Latitude Number"
                />
                </div>
                 <div className="latitudeno d-flex flex-column gap-2 w-50">
                <label>Longitude Number<small>*</small> </label>
                <input
                  type="text"
                  required
                  className="form-control"
                  autoComplete="new-Longitude"
                  placeholder="Enter Longitude Number"
                />
                </div>
              </div>
              
          </div>
              <div className="bottombtn w-100 justify-content-center d-flex gap-3 mt-4">
                <Link to="/location-list" className="btn backbtn">
                  Back
                </Link>

                <button type="submit" className="btn btn-primary" disabled={loading}>
                  {loading ? "Updateting..." : "Update"} 
                </button>
              </div>
            </form>
          </section>
        </div>
      </div>
    </PageLayout>
  );
}